import { createSlice } from "@reduxjs/toolkit";

const initialState = {
	value: 0,
};

const qCardSlice = createSlice({
	name: "qCardCertificates",
	initialState: initialState,
	reducers: {
		updateQCard(state, action) {
			// console.log("update qCardCertificates");
			// console.log(action);

			state.value = action.payload.value;
		},
	},
});

export const qCardCertificatesActions = qCardSlice.actions;

export default qCardSlice;
